import { useSettings } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { type NCWalletTokenCardsEntry, type NCWalletTokenCardsProps } from '@capsicum/features/nc-wallet/shared';
import { useCallback } from 'react';

import { useNCWPartnerRouting } from './useNCWPartnerRouting';

export const useNCWalletTokenCards = ({
	name,
	onBodyClick,
	onLogoClick
}: Pick<NCWalletTokenCardsProps, 'name' | 'onBodyClick' | 'onLogoClick'>) => {
	const { push } = useRouter();

	const { routeToNcwPartnerDetail } = useNCWPartnerRouting();

	const {
		settings: { isPoblanoPartnerPageEnabled }
	} = useSettings();

	const createLogoClickListener = useCallback(
		(entry: NCWalletTokenCardsEntry) => {
			if (entry.type === 'balance' && entry.tokenType === 'external-token') {
				return () => {
					onLogoClick?.(entry);

					push(`/currency/${entry.currencyId}`);

					return;
				};
			}

			return () => {
				onLogoClick?.(entry);
				push([`/partner/${entry.partnerID}`, !name ? null : `referrer=${name}`].filter(part => part).join('?'));
			};
		},
		[push, name, onLogoClick]
	);

	const createBodyClickListener = useCallback(
		(entry: NCWalletTokenCardsEntry) => {
			if (entry.type === 'balance' && entry.tokenType === 'external-token') {
				return () => {
					onBodyClick?.(entry);

					push(`/currency/${entry.currencyId}`);

					return;
				};
			}

			if (isPoblanoPartnerPageEnabled)
				return () => {
					onBodyClick?.(entry);

					const queryParameters = ['tab=token'];

					if (name) queryParameters.push(`referrer=${name}`);

					push(`/partner/${entry.partnerID}?${queryParameters.join('&')}`);
				};

			if (entry.type === 'balance' && entry.amount)
				return () => {
					onBodyClick?.(entry);
					routeToNcwPartnerDetail(entry.shortCode);
				};

			return;
		},
		[name, onBodyClick, routeToNcwPartnerDetail, isPoblanoPartnerPageEnabled, push]
	);

	return {
		createBodyClickListener,
		createLogoClickListener
	};
};
